module.exports = __webpack_public_path__ + "static/img/mi-css_logo2_black.67bc4a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mi-css_logo2_black.png
// module id = NEfD
// module chunks = 3